import React from 'react';

import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SortableRowContext } from 'components/contentRegister/components/sortableTable/components/SortableRow';

export default function DragPreviewTable({
  cellClassName,
  columns,
  row,
  width,
}) {
  return (
    <table
      className='tw-table-fixed tw-border-separate tw-border-spacing-0 tw-bg-blue-025 tw-shadow-lg'
      style={{ width }}
    >
      <colgroup>
        {columns.map((column) => (
          <col key={column.id} style={{ width: column.width }} />
        ))}
      </colgroup>

      <tbody>
        {/* This component only ever exists while a drag is in progress, so no need to compute the values */}
        <SortableRowContext.Provider
          value={{ isDragging: true, isSortable: true }}
        >
          <tr className='tw-group tw-cursor-grabbing'>
            {row.getVisibleCells().map((cell) => (
              <td
                className={classNames(
                  cellClassName,
                  cell.column.columnDef.meta?.classNames,
                )}
                key={cell.id}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        </SortableRowContext.Provider>
      </tbody>
    </table>
  );
}

DragPreviewTable.propTypes = {
  cellClassName: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      width: PropTypes.number,
    }),
  ).isRequired,
  row: PropTypes.shape({ getVisibleCells: PropTypes.func.isRequired })
    .isRequired,
  width: PropTypes.number,
};
